import type { IntroCodeData, SelectedTariffResponse } from '../types/purchaseTypes';

export function calculatePayableAmount(
  selectedTariff: SelectedTariffResponse | undefined,
  introCodeData: IntroCodeData | null,
): number {
  if (!selectedTariff?.data) return 0;
  const baseAmount = Number(selectedTariff.data.amount_payable) || 0;
  const discountAmount = introCodeData?.data?.discount_amount || 0;
  return Math.max(baseAmount - discountAmount, 0);
}

export function extractTariffId(tariffSlug: string | null | undefined): string | undefined {
  return tariffSlug?.match(/\d+$/)?.[0];
}

export function buildInvoiceUrl(tariffId: string, introCode?: string | null): string {
  const basePath = `/orders/invoice/${tariffId}`;
  return introCode ? `${basePath}?inc=${introCode}` : basePath;
}
